/**
 * 데이터 접근 권한 서비스
 */

import apiClient from './api';
import {
  DataAccessPermission,
  DataAccessPermissionRequest,
} from '../types/admin';

export const dataAccessPermissionService = {
  /**
   * 관리자별 데이터 접근 권한 조회
   */
  async getDataAccessPermissions(adminId?: number): Promise<DataAccessPermission[]> {
    const params = new URLSearchParams();
    if (adminId) params.append('admin_id', adminId.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: DataAccessPermission[] }>(`/admin/data-access-permissions?${params.toString()}`);
    // return response.data.data;

    // 임시: 더미 데이터 반환
    return [];
  },

  /**
   * 데이터 접근 권한 상세 조회
   */
  async getDataAccessPermission(id: number): Promise<DataAccessPermission> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { permission: DataAccessPermission } }>(`/admin/data-access-permissions/${id}`);
    // return response.data.data.permission;

    throw new Error('Not implemented');
  },

  /**
   * 데이터 접근 권한 설정
   */
  async setDataAccessPermission(data: DataAccessPermissionRequest): Promise<DataAccessPermission> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.post<{ data: { permission: DataAccessPermission } }>('/admin/data-access-permissions', data);
    // return response.data.data.permission;

    throw new Error('Not implemented');
  },

  /**
   * 데이터 접근 권한 수정
   */
  async updateDataAccessPermission(id: number, data: Partial<DataAccessPermissionRequest>): Promise<DataAccessPermission> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.put<{ data: { permission: DataAccessPermission } }>(`/admin/data-access-permissions/${id}`, data);
    // return response.data.data.permission;

    throw new Error('Not implemented');
  },

  /**
   * 데이터 접근 권한 삭제
   */
  async deleteDataAccessPermission(id: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    // await apiClient.delete(`/admin/data-access-permissions/${id}`);

    throw new Error('Not implemented');
  },
};

